import React, { useEffect, useMemo, useState } from "react";
import SectionField from "../section/SectionField";
import styles from "./NumberComponent.module.scss";
import InputTextArea from "components/shared/textArea/InputTextArea";
import FileUploadButton from "components/shared/fileUploadButton/FileUploadButton";
import { Controller, useForm } from "react-hook-form";
import TriggerButton from "components/shared/createTriggerButton/TriggerButton";
import { useDispatch, useSelector } from "react-redux";
import { setDroppedItems, setUpdateDroppedItems } from "redux/slices/formSlice";
import { findSelectedData, handleFile, randomIntFromInterval } from "utils/utils";
import DeleteIcon from "@mui/icons-material/Delete";
import { setPublish } from "redux/slices/globalSlice";
import { useNavigate, useParams } from "react-router-dom";
import { setDroppedItems as setTriggerList } from "redux/slices/triggerSlice";
import { Box, Input } from "@mui/material";
import toast from "react-hot-toast";

const NumberComponent = () => {
   const { publish } = useSelector((state) => state?.global);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { formId } = useParams();

  const [dependent, setDependent] = useState(false);
  const [min, setMin] = useState(10);
  const [max, setMax] = useState(20);
      const [file, setFile] = useState("");

  const { triggerDroppedList } = useSelector((state) => state.trigger);
  const { droppedItems, selectedData } = useSelector((state) => state.form);

  const { register, handleSubmit, control, watch, setValue: setValues } = useForm({
    defaultValues: {
      showInstructions: selectedData?.showInstructions ||  false,
      instructions: selectedData?.instructions || "",
      enableDependentQuestions: selectedData?.whenAnswerOutsideRange ? true : false,
      whenAnswerOutsideRange: "",
      range: selectedData?.whenAnswerOutsideRange ? [selectedData?.whenAnswerOutsideRange?.split("-")[0], selectedData?.whenAnswerOutsideRange?.split("-")[1]] : [10, 20]
    },
  });

  const handleChange = (field, value) => {
    const updatedData = { [field]: value };

    if (field === "enableDependentQuestions") {
      setDependent(value);
    } else if (field === "dependentOptions") {
      setDependent(true);
    }

    // dispatch(setUpdateDroppedItems({ id: selectedData?.id, updatedData }));
    dispatch(setPublish(true));
  };

  const handleTextChange = (e, fieldName) => {
    handleChange(fieldName, e.target.value);
  };

  const handleFileChange = (file, setIsLoading) => {
    handleFile(file, droppedItems, selectedData, dispatch, setDroppedItems, setIsLoading);;
    dispatch(setPublish(true));
  };

  const onSubmit = (data) => {
    // console.log("Form Data:", data);
  };

  const handleImageDelete = (src, selectedItem) => {
    const updatedMedia = selectedItem?.data?.media?.filter(
      (media) => media.path !== src
    );

    const updatedData = { media: updatedMedia };

    dispatch(setUpdateDroppedItems({ id: selectedData?.id, updatedData }));
    dispatch(setPublish(true));
  };

  const handleOpenImage = (src) => {
    window.open(src, "__blank");
  };

  const currentItem = useMemo(() => {
    // Check for a match in the main fields
    let foundItem = droppedItems.find((item) => item.id === selectedData.id);

    if (!foundItem) {
      // If not found, search in dependent fields
      droppedItems.forEach((item) => {
        const dependentMatch = item.dependentField.find(
          (depField) => depField.id === selectedData.id
        );
        if (dependentMatch) {
          foundItem = dependentMatch;
        }
      });
    }

    return foundItem;
  }, [droppedItems, selectedData]);

  const handleTrigger = () => {
    const uniqueId = Date.now() + randomIntFromInterval(1000, 9999);
    dispatch(setTriggerList([
      ...triggerDroppedList, {
        ...currentItem,
        id: uniqueId
      }
    ]));
    navigate(`/create/triggers/${formId || ""}`);
  };

  const handleDependentChange = (e) => {
    const { name, value } = e.target;
    const newValue = value.trim();

    if (name === "min") {
      setMin(newValue);
    } else if (name === "max") {
      setMax(newValue);
    }

    // Update Redux state immediately
    const updatedRange = name === "min" ? `${newValue}-${max}` : `${min}-${newValue}`;
    // handleChange("whenAnswerOutsideRange", updatedRange);
  };

  // useEffect(() => {
  //   if (selectedData) {
  //     setDependent(true);

  //     if (selectedData?.whenAnswerOutsideRange) {
  //       const [newMin, newMax] = selectedData.whenAnswerOutsideRange.split("-");
  //       setMin(newMin);
  //       setMax(newMax);
  //     } else {
  //       handleChange("enableDependentQuestions", true);
  //       handleChange("whenAnswerOutsideRange", `${min}-${max}`);
  //     }
  //   }
  // }, [selectedData]); // Prevents unnecessary updates
  // useEffect(() => {
  //   console.log('watch("range")', watch("range"))
  //   setValues("whenAnswerOutsideRange", `${Number(watch("range")[0])}-${Number(watch("range")[1])}`)
  // }, [watch("range")])

  useEffect(() => {
    if (watch("enableDependentQuestions")) {
      if (selectedData?.whenAnswerOutsideRange) {

        setValues("whenAnswerOutsideRange", selectedData?.whenAnswerOutsideRange)
        let arr = selectedData?.whenAnswerOutsideRange?.split("-")

      }
      else {
        let arr = watch("range")

        setValues("whenAnswerOutsideRange", `${arr[0]}-${arr[1]}`)
        // setValues("range", [10, 29])
      }
    } else {
      setValues("whenAnswerOutsideRange", "")
      setValues("range", [])
      let clearDrop = droppedItems?.map((e) => {
        return e?.id == selectedData?.id ? { ...e, dependentField: [] } : e
      })
      dispatch(setDroppedItems(clearDrop))
    }
  }, [watch("enableDependentQuestions")])
  useEffect(() => {
    if (!selectedData) return;
    const { range, whenAnswerOutsideRange, ...rest } = watch()

    const timeout = setTimeout(() => {
      dispatch(setUpdateDroppedItems({
        id: selectedData.id, updatedData: {
          ...rest,
          whenAnswerOutsideRange: range.length ?  `${range[0]}-${range[1]}` : ""
        }
      }));
      // dispatch(setPublish(true));
    }, 500);

    return () => clearTimeout(timeout); // Cleanup on unmount
  }, [watch(), selectedData]);

  return (
    <>
      <SectionField
        placeholder="Please enter your question here."
        message="Required"
      />
      <div className={styles?.instructionsForm}>
        <h4>Instructions</h4>
        <div className={styles?.formField}>
          <Controller
            name="instructions"
            control={control}
            render={({ field }) => (
              <InputTextArea
                {...field}
                control={control}
                onChange={(e) => {
                  field.onChange(e);
                  dispatch(setPublish(true))
                }}
                type="textarea"
                name="Optional"
                placeholder="Optional"
                // onChange={(e) => handleTextChange(e, "instructions")}
                className={styles.textArea}
              />
            )}


          />

        </div>
        <div className={styles?.formField}>
          {currentItem?.data?.media?.length ? (
            <div className={styles.imageContainer}>
              {currentItem?.data?.media?.map((src, index) => (
                <div
                  key={index}
                  className={styles.imageWrapper}
                  onClick={() => handleOpenImage(src.path)}
                >
                  <img src={src.path} alt="" />
                  <div
                    className={styles.cancelIcon}
                    onClick={(event) => {
                      event.preventDefault();
                      event.stopPropagation();
                      handleImageDelete(src.path, currentItem);
                    }}
                  >
                    <DeleteIcon sx={{ width: "20px", height: "20px" }} />
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <FileUploadButton
              name="mediaFile"
              control={control}
              onFileChange={handleFileChange}
            />
          )}
        </div>
      </div>

      <form className={styles.formContainer} onSubmit={handleSubmit(onSubmit)}>
      <div>
                    <label>
                        <input
                            disabled={
                                !watch("instructions") && !file && !currentItem?.data?.media?.length > 0
                            }
                            type="checkbox"
                            {...register("showInstructions")}
                        // onChange={(e) =>
                        //     handleChange("showInstructions", e.target.checked)
                        // }
                        />
                        Show instructions by default
                    </label>
                </div>
        <div>
          <label>
            <Controller
              name={`enableDependentQuestions`}
              control={control}
              render={({ field }) => (
                <input
                  type="checkbox"
                  {...field}
                  checked={field.value}
                  onChange={(e) => {
                    if (!e.target.checked) {
                      if (window.confirm("Un-checking this option will remove all dependent questions and any data collected from those questions. Are you sure?")) {
                        field.onChange(e)
                        dispatch(setPublish(true))
                      } else {
                        return
                      }
                    }
                    field.onChange(e)
                    dispatch(setPublish(true))
                  }}

                />


              )}
            />
            Enable Dependent Questions

          </label>
          {watch("enableDependentQuestions") && (
            <>
              <label style={{ margin: "10px 0", display: "block" }}>Add Dependent Question When Number Is Outside Range:</label>
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <Controller
                  name="range[0]"
                  control={control}
                  render={({ field }) => (
                    <Input
                      type="number"
                      inputProps={{ min: 1 }}
                      onChange={(e) => {
                        field.onChange(e);
                        dispatch(setPublish(true))
                      }}
                      value={field?.value}
                      {...field}
                      control={control}
                      sx={{
                        width: "90px",
                        textAlign: "center",
                        border: "1px solid #ccc",
                        borderRadius: "5px",
                        padding: "5px",
                      }}
                    />
                  )}


                />
                <span>-</span>
                <Controller
                  name="range[1]"
                  control={control}
                  render={({ field }) => (
                    <Input
                      type="number"
                      inputProps={{ min: 1 }}
                      {...field}
                      control={control}
                      onChange={(e) => {
                        dispatch(setPublish(true))
                        field.onChange(e);

                      }}
                      value={field?.value}
                      sx={{
                        width: "90px",
                        textAlign: "center",
                        border: "1px solid #ccc",
                        borderRadius: "5px",
                        padding: "5px",
                      }}
                    />
                  )}


                />
              </Box>
            </>
          )}
        </div>
        <TriggerButton handleClick={() =>{
                    if(!publish){
                    handleTrigger()
                }else {
                    toast.error("There are unpublished changes");
                }
                }
                
                } />
      </form>
    </>
  );
};

export default NumberComponent;
